import { useImageFromFabricData } from "@/components/canvas/hooks/useImageFromFabricData";
import { Template } from "@/lib/types";
import { cn } from "@/lib/utils";

type Props = { data: Template["canvas_data"]; previewSize: "small" | "full" };

export const TemplatePreview: React.FC<Props> = ({ data, previewSize }) => {
  const imageDataUrl = useImageFromFabricData(data, { multiplier: previewSize === "small" ? 0.05 : 1 });
  return (
    <img
      src={imageDataUrl}
      alt="template preview"
      className={cn("w-full object-contain", {
        "h-[100px]": previewSize === "small",
        "h-full": previewSize === "full",
      })}
    />
  );
};
